import { Button, Flex, Separator } from "@radix-ui/themes";
import { GlobeIcon } from "@radix-ui/react-icons";

import AnnotationViewSelector from "./annotation-view-selector";
import { GondolaSelect } from "./gondola-select";
import CameraDropdown from "./camera-dropdown";
import CameraModeSelector from "./camera-mode-selector";
import DefaultCameras from "./default-cameras";
import FavoriteCameras from "./favourite-cameras";
import { Gondola } from "@/shared/api";

interface AnnotationHeaderDefaultProps {
  gondolaDropdownValue: Gondola | null;
  isGondolaDisabled: boolean;
  hasAnnotationViewSelector?: boolean;
  onGondolaChange: (value: Gondola | null) => void;
  onCameraSelect: (cameraId: string) => void;
  onOpenMap?: () => void;
  isOrderSelected?: boolean;
}

const AnnotationHeaderDefault = ({
  gondolaDropdownValue,
  isGondolaDisabled,
  hasAnnotationViewSelector = true,
  onGondolaChange,
  onCameraSelect,
  onOpenMap,
}: AnnotationHeaderDefaultProps) => {
  return (
    <Flex
      p="1"
      justify={hasAnnotationViewSelector ? "between" : "end"}
      gap="1"
      align="center"
    >
      {hasAnnotationViewSelector && <AnnotationViewSelector />}

      <Flex gap="1" minWidth="0" align="center">
        <DefaultCameras />
        <Separator orientation="vertical" className="flex-shrink-0" />
        <FavoriteCameras />
        <Separator orientation="vertical" className="flex-shrink-0" />

        <GondolaSelect
          value={gondolaDropdownValue}
          disabled={isGondolaDisabled}
          onValueChange={onGondolaChange}
        />

        <CameraModeSelector />

        <CameraDropdown onCameraSelect={onCameraSelect} />

        {onOpenMap && (
          <>
            <Separator orientation="vertical" className="flex-shrink-0" />
            <Button
              size="1"
              variant="soft"
              color="gray"
              onClick={onOpenMap}
              disabled={isGondolaDisabled}
            >
              <GlobeIcon />
              Map
            </Button>
          </>
        )}
      </Flex>
    </Flex>
  );
};

export default AnnotationHeaderDefault;
